import { render, staticRenderFns } from "./supplier-commitment-type-toggle.vue?vue&type=template&id=749236f6"
import script from "./supplier-commitment-type-toggle.vue?vue&type=script&lang=js"
export * from "./supplier-commitment-type-toggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports